export const getDateBankCards = (data: string): string => {
  // eslint-disable-next-line camelcase
  const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
  // eslint-disable-next-line camelcase
  if (date_regex.test(data)) {
    const dd = data.slice(0, 2);
    const mm = data.slice(3, 5);
    const yyyy = data.slice(6, 10);
    return `${yyyy}-${mm}-${dd}`;
  }
  return "";
};

export const birthDateValidate = (value) => {
  const parts = value?.split("-");

  if (
    parts?.length !== 3 ||
    parts[0]?.length !== 2 ||
    parts[1]?.length !== 2 ||
    parts[2]?.length !== 4
  ) {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    return "profile.account.birthday.incorrect";
  }

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  const birthDate = new Date(year, month - 1, day);

  if (
    !(
      birthDate &&
      birthDate.getMonth() + 1 === month &&
      birthDate.getDate() === day
    )
  ) {
    return "profile.account.birthday.incorrect";
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    // eslint-disable-next-line no-plusplus
    age--;
  }
  if (age < 18 || age > 124) {
    return "profile.account.birthday.incorrect";
  }

  return true;
};

export const birthDateValidateReverse = (value) => {
  const parts = value.split("-");

  if (
    parts.length !== 3 ||
    parts[0].length !== 4 ||
    parts[1].length !== 2 ||
    parts[2].length !== 2
  ) {
    return "profile.account.birthday.incorrect";
  }

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);
  const birthDate = new Date(year, month - 1, day);

  if (
    !(
      birthDate &&
      birthDate.getMonth() + 1 === month &&
      birthDate.getDate() === day
    )
  ) {
    return "profile.account.birthday.incorrect";
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    // eslint-disable-next-line no-plusplus
    age--;
  }

  if (age < 18 || age > 118) {
    return "profile.account.birthday.incorrect";
  }

  return true;
};

export function validateCardExpiry(date) {
  if (!/^\d{2}\/\d{2}$/.test(date)) {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    return "popup.payment.card.expire.date.error";
  }

  const [expMonthStr, expYearStr] = date.split("/");
  const expMonth = parseInt(expMonthStr, 10);
  const expYear = parseInt(`20${expYearStr}`, 10);

  if (expMonth < 1 || expMonth > 12) {
    return "popup.payment.card.expire.date.error";
  }

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  if (
    expYear < currentYear ||
    (expYear === currentYear && expMonth <= currentMonth)
  ) {
    return "popup.payment.card.expire.date.error";
  }

  return true;
}

export function validateDocumentExpiry(date) {
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    return "popup.payment.card.expire.date.error";
  }

  const [expDayStr, expMonthStr, expYearStr] = date.split("/");
  const expDay = parseInt(expDayStr, 10);
  const expMonth = parseInt(expMonthStr, 10);
  const expYear = parseInt(expYearStr, 10);

  if (expMonth < 1 || expMonth > 12) {
    return "popup.payment.card.expire.date.error";
  }

  const expDate = new Date(expYear, expMonth - 1, expDay);
  const currentDate = new Date();

  currentDate.setHours(0, 0, 0, 0);

  if (expDate < currentDate) {
    return "popup.payment.card.expire.date.error";
  }

  return true;
}
